import { MouseEventHandler, ReactNode } from 'react';

interface Props {
  href: string;
  children: ReactNode | string;
  target?: '_blank' | '_self';
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}

const KiaLink = ({ href, children, target = '_self', onClick }: Props) => {
  return (
    <a
      className="no-underline rounded-[100px] gap-2 text-white p-[.2rem] pl-3 inline-flex items-center cursor-pointer leading-[17px] bg-black justify-between"
      href={href}
      target={target}
      onClick={onClick}
    >
      <span className="text-xs font-semibold">{children}</span>
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="19" height="19" rx="9.5" fill="white"></rect>
        <path
          d="M8.1665 13.5L12.1665 9.5L8.1665 5.5"
          stroke="#05141F"
          strokeWidth="2"
        ></path>
      </svg>
    </a>
  );
};

export default KiaLink;
